import { Hide, Image, Show } from '@chakra-ui/react';
import React from 'react';
import { Link } from 'react-router-dom';
import logoDesktop from '@/assets/chromabet/images/logo.png';
import logoMb from '@/assets/chromabet/images/logo-mb.png';
import { THEME_NAME } from '@/constants/themeConfig';

export default function Index() {
  return (
    <Link to="/">
      <Show above="lg">
        <Image src={logoDesktop} alt={THEME_NAME.chromabet} mx="auto" pb={2} />
      </Show>
      <Hide above="lg">
        <Image src={logoMb} alt={THEME_NAME.chromabet} h="8" />
      </Hide>
    </Link>
  );
}
